import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import { putCaja as modifCaja } from "../helpers/rutaCajas";
import { Modal, Button } from "react-bootstrap";
import "animate.css";

const ModalFormCaja = ({ caja, handleClose, show }) => {
  const [formValues, setFormValues] = useState({
    codcaj: "",
    fecha: "",
    descripcion: "",
    montoInicial: "",
    saldoActual: "",
    tipo: "CAJA",     // ← NUEVO
    // bancarios (opcionales si tipo === "BANCO")
    banco: "",
    alias: "",
    cbu: "",
    numero: "",
    moneda: "ARS",
  });

  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (caja && caja._id) {
      setFormValues({
        codcaj: caja.codcaj || "",
        fecha: caja.fecha ? moment(caja.fecha).format("YYYY-MM-DDTHH:mm") : "",
        descripcion: caja.descripcion || "",
        montoInicial: caja.montoInicial ?? "",
        saldoActual: caja.saldoActual ?? caja.montoInicial ?? "",

        // ↓↓↓ completa según el modelo nuevo
        tipo: caja.tipo || "CAJA",
        banco: caja.banco || "",
        alias: caja.alias || "",
        cbu: caja.cbu || "",
        numero: caja.numero || "",
        moneda: caja.moneda || "ARS",
      });
    }
  }, [caja]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((s) => ({
      ...s,
      [name]: value,
      // si tocan montoInicial, reflejamos en saldo (aunque está disabled)
      ...(name === "montoInicial" ? { saldoActual: value } : null),
      // si cambian tipo a CAJA, limpiamos datos bancarios para no mandar basura
      ...(name === "tipo" && value === "CAJA"
        ? { banco: "", alias: "", cbu: "", numero: "", moneda: "ARS" }
        : null),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Construimos payload sin vacíos
    const payload = {
      fecha: formValues.fecha || undefined,
      descripcion: formValues.descripcion.trim(),
      montoInicial: Number(formValues.montoInicial || 0),
      saldoActual: Number(formValues.saldoActual || 0),
      tipo: formValues.tipo, // CAJA / BANCO
      ...(formValues.tipo === "BANCO"
        ? {
            banco: formValues.banco || "",
            alias: formValues.alias || "",
            cbu: formValues.cbu || "",
            numero: formValues.numero || "",
            moneda: formValues.moneda || "ARS",
          }
        : {
            // si es CAJA, aseguramos limpiar campos bancarios
            banco: "",
            alias: "",
            cbu: "",
            numero: "",
            moneda: "ARS",
          }),
    };

    try {
      const resp = await modifCaja(caja._id, payload);
      console.log("✅ Caja/Fondo actualizado:", resp);

      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 1500);
    } catch (err) {
      console.error("❌ Error al guardar:", err);
      alert(err?.response?.data?.message || "Error al guardar la caja/fondo");
    }
  };

  const esBanco = formValues.tipo === "BANCO";

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Modificar Fondo</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="form-group mt-2">
              <label>Fecha</label>
              <input
                type="datetime-local"
                className="form-control"
                name="fecha"
                required
                value={formValues.fecha}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Tipo</label>
              <select
                className="form-control"
                name="tipo"
                value={formValues.tipo}
                onChange={handleChange}
                required
              >
                <option value="CAJA">CAJA (efectivo)</option>
                <option value="BANCO">BANCO (transferencias)</option>
              </select>
            </div>

            <div className="form-group mt-2">
              <label>Descripción</label>
              <input
                type="text"
                className="form-control"
                name="descripcion"
                required
                value={formValues.descripcion}
                onChange={handleChange}
                placeholder={esBanco ? "Ej: Santander Río" : "Ej: Caja 2025"}
              />
            </div>

            {esBanco && (
              <>
                <div className="form-group mt-2">
                  <label>Banco</label>
                  <input
                    type="text"
                    className="form-control"
                    name="banco"
                    value={formValues.banco}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group mt-2">
                  <label>Alias</label>
                  <input
                    type="text"
                    className="form-control"
                    name="alias"
                    value={formValues.alias}
                    onChange={handleChange}
                    placeholder="ALIAS.CBU"
                  />
                </div>
                <div className="form-group mt-2">
                  <label>CBU</label>
                  <input
                    type="text"
                    className="form-control"
                    name="cbu"
                    value={formValues.cbu}
                    onChange={handleChange}
                    placeholder="22 dígitos"
                  />
                </div>
                <div className="form-group mt-2">
                  <label>Número de cuenta</label>
                  <input
                    type="text"
                    className="form-control"
                    name="numero"
                    value={formValues.numero}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group mt-2">
                  <label>Moneda</label>
                  <select
                    className="form-control"
                    name="moneda"
                    value={formValues.moneda}
                    onChange={handleChange}
                  >
                    <option value="ARS">ARS</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                  </select>
                </div>
              </>
            )}

            <div className="form-group mt-2">
              <label>Monto Inicial</label>
              <input
                type="number"
                className="form-control"
                name="montoInicial"
                required
                value={formValues.montoInicial}
                onChange={handleChange}
                disabled
              />
            </div>

            <div className="form-group mt-2">
              <label>Saldo Actual</label>
              <input
                type="number"
                className="form-control"
                name="saldoActual"
                value={formValues.saldoActual}
                readOnly
              />
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit" variant="dark">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormCaja;
